var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{style:({
    'margin': !_vm.isSimulation && _vm.isDesktop ? '15px 30px 15px 30px' : '15px' 
  }),attrs:{"color":_vm.data.Color,"dense":"","text":"","icon":_vm.data.Icon,"border":"left"}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }